import React, { useContext, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import SettingsTableComponent from "../../components/tables/SettingsTableComponent";
import PageLayout from "../../layouts/PageLayout";
import { getAllCountries, getSettings, refreshSimsSupervisors, setSetting } from "../../APIs/SettingRequests";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { ButtonComponent } from "../../components/elements";
import { Link } from "react-router-dom";

export default function SettingsListPage() {

    const { t } = useContext(TranslatorContext);
    const [settings, setSettings] = React.useState([]);
    const [countries, setCountries] = React.useState([]);
    const [defaultCountry, setDefaultCountry] = React.useState('');

    const listSettingsFunction = (page=1) => {
        getSettings().then((res) => {
            setSettings(res.data.data);
            const defaultCountrySetting = res.data.data.find(setting => setting.key === 'default_country');
            //console.log(defaultCountrySetting);
            if (defaultCountrySetting) {
                setDefaultCountry(parseInt(defaultCountrySetting.value));
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const getAllCountriesAction = (page=1) => {
        getAllCountries(page, 500).then((res) => {
            setCountries(res.data.data);
            //console.log(res.data.data.find(country => country.id === defaultCountry)?.name );
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
        });
    }

    const updateSettingAction = (key,value) => {
        setSetting(key,value).then((res)=> {
            listSettingsFunction();
            const notify = () => toast.success(res.data.message);
            notify();
        }).catch((error)=> {
            console.log(error);
        });
    }

    const refreshSimsSupervisorsAction = () => {
        refreshSimsSupervisors().then((res)=> {
            const notify = () => toast.success(t("Supervisors assign refreshed successfully"));
            notify();
        }).catch((error)=> {
            console.log(error);
        });
    }

    useEffect(() => {
        listSettingsFunction();
        getAllCountriesAction();
    }, []);
    const thead = [t("name"), t("value"), t("created"), t("action")];


    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('settings')}</h3>
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        <SettingsTableComponent 
                            thead={ thead }
                            tbody={ settings }
                            refreshPage={ listSettingsFunction }
                        />
                    </div>
                </Col>
            </Row>

            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <h3 className="mc-breadcrumb-title">{t('default_country')}</h3>
                        <Select
                            options={countries.map(country => ({ value: country.id, label: country.name }))}
                            onChange={(selectedOption) => {
                                const selectedCountry = countries.find(country => country.id === selectedOption.value);
                                const countryId = selectedCountry.id;
                                updateSettingAction('default_country', countryId);
                                
                            }}
                            value={{ value: defaultCountry, label: countries.find(country => country.id === defaultCountry)?.name }}
                            placeholder={t('select_country')}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isDisabled={countries.length === 0}
                        />
                    </div>
                </Col>    
            </Row>


            <div className="text-left" onClick={refreshSimsSupervisorsAction}>
                <Link className="mc-btn primary sm">
                    <i className="material-icons">refresh</i>
                    <span>{t('refresh')}</span>
                </Link>
            </div>
        </PageLayout>
    );
}